import PropTypes from 'prop-types';

// Spinner
export const DURATION = 1200;
export const SVG_RADIUS = 20;
export const SVG_CIRCUMFERENCE = SVG_RADIUS * 2 * Math.PI;
export const SVG_SIZE = 48;
export const ROTATION_TRANSFORM = 'rotate(-90 24 24)';
export const SVG_CENTER = 24;
export const SPINNER_RADIUS = 20;
export const SPINNER_ROTATION_DEGREES = 183;
export const SPINNER_DASHARRAY_MIN = 0.01;
export const SPINNER_DASHARRAY_MAX = 0.99;

// Spinner animation
export const SPINNER_KEYTIMES = '0; 0.5; 1';
export const SPINNER_DASHARRAY_HALF = 0.5;
export const SPINNER_DASHOFFSET_FACTOR = 0.49;

// Dots
export const DOTS_ANIMATION_DURATION = 300;
export const DOTS_TOTAL_ANIMATION_DURATION = DOTS_ANIMATION_DURATION * 10;
export const OVERSHOOT_FACTOR = 1.3;
export const UNDERSHOOT_FACTOR = 0.2;
export const BOUNCY_CURVE = '0.2 1 0.8 1';
export const DOTS_SPACING_X = 3;
export const DOTS_BASE_Y_FACTOR = 3;
export const DOTS_JUMP_HEIGHT_FACTOR = 1;
export const DOTS_PADDING_FACTOR = 0.5;

// Dots fadeout
export const DOTS_FADEOUT_KEYTIMES = '0; 0.7; 0.8; 1';
export const DOTS_FADEOUT_VALUES = '1; 1; 0; 0';

// Dots animation
export const DOT1_ANIMATION_KEYTIMES = '0; 0.1; 0.2; 1';
export const DOT2_ANIMATION_KEYTIMES = '0; 0.3; 0.4; 0.5; 1';
export const DOT3_ANIMATION_KEYTIMES = '0; 0.6; 0.7; 0.8; 1';

// Dots color keytimes
export const DOT1_COLOR_KEYTIMES = '0; 0.3; 0.4; 1';
export const DOT2_COLOR_KEYTIMES = '0; 0.3; 0.4; 0.6; 0.7; 1';
export const DOT3_COLOR_KEYTIMES = '0; 0.5; 0.6; 0.8; 1';

// Dots native fadeout
export const DOT_FADEOUT_INPUT_RANGE = [0, 0.7, 0.8, 1];
export const DOT_FADEOUT_OUTPUT_RANGE = [1, 1, 0, 0];

// Dots native animation
export const DOT1_ANIMATION_INPUT_RANGE = [0, 0.1, 0.2, 1];
export const DOT2_ANIMATION_INPUT_RANGE = [0, 0.3, 0.4, 0.5, 1];
export const DOT3_ANIMATION_INPUT_RANGE = [0, 0.6, 0.7, 0.8, 1];

// Backdrop
export const BACKDROP_OPACITY = 0.06;
export const BACKDROP_Z_INDEX = 1400;

// Space
export const SPACE_WITH_LABEL = 3;
export const SPACE_WITHOUT_LABEL = 0;

// Style
export const DOTS_STYLE = 'dots';
export const propTypes = {
  color: PropTypes.string.isRequired,
  baseColor: PropTypes.string,
  label: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  dotsize: PropTypes.number,
  thickness: PropTypes.number.isRequired,
  isStatic: PropTypes.bool
};